import httpClient from '/src/utils/httpClient';

export function updateHeaderApiCall({ id, imageSize, imageShape = '', image, link, name, nameSize, view }) {
  const profileId = localStorage.getItem('unilinkProfileId');

  return httpClient.put(`api/profiles/${profileId}/email-marketing/block/header`, {
    id,
    image,
    imageSize: Number(imageSize),
    imageShape: imageShape,
    imageHyperlink: link,
    text: name,
    textSize: Number(nameSize),
    view,
  });
}
